import React from "react";
import { Box, Stack } from "@mui/material";
import OrderCard from "./OrderCard/OrderCard";

const OrderList = ({ orders, onReorder }) => {
  if (!orders.length) return <Box>No orders found.</Box>;

  return (
    <Stack spacing={4}>
      {orders.map((order) => (
        <OrderCard key={order._id} order={order} onReorder={onReorder} />
      ))}
    </Stack>
  );
};

export default OrderList;
